import styled, { css } from "styled-components";

import colors from "@src/common/styles/colors";
import {
  DEFAULT_MARGIN_L,
  DEFAULT_MARGIN_M,
  DEFAULT_MARGIN_S,
  ZIndex,
} from "@src/common/styles/const";
import {
  defaultBounceTransition,
  defaultLetterSpacing,
  defaultTransition,
  media,
} from "@src/common/styles/mixins";

interface OptionsProps {
  isVisible: boolean;
  isLastInRow: boolean;
  isPositionDown?: boolean;
}

export const KebabMenuWrapper = styled.div<{ hasRelativePosition: boolean }>`
  ${({ hasRelativePosition }) =>
    hasRelativePosition
      ? css`
          position: relative;
        `
      : css`
          position: absolute;
          top: 10px;
          right: 10px;
        `}
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 6px;
  color: ${colors.almostBlack};
  width: 35px;
  height: 35px;
  cursor: pointer;
  ${defaultTransition};
`;

export const KebabOptionsWrapper = styled.div<OptionsProps>`
  white-space: nowrap;
  z-index: ${ZIndex.Popup};
  background-color: ${colors.white};
  overflow: hidden;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  ${defaultBounceTransition};
  visibility: ${(p) => (p.isVisible ? "visible" : "hidden")};
  transform: scale(${(p) => (p.isVisible ? 1 : 0)});

  ${(p) =>
    css`
      ${media.up("MOBILE")`
        ${p.isPositionDown === true ? "top: 50px; left: -115px;" : "top: 0px;"}
        border-radius: 6px;
        position: absolute;
      `}
    `}

  ${(p) =>
    p.isLastInRow
      ? css`
          transform-origin: top right;
          right: 100%;
        `
      : css`
          transform-origin: top left;
          left: 100%;
        `}

  ${media.down("MOBILE")`
    position: fixed;
    left: 0;
    bottom: 0;
    top: 50px;
    width: 100vw;
    z-index: ${ZIndex.Header + ZIndex.Popup};
    border-radius: 6px 6px 0 0;
    transform-origin: bottom center;
`}
`;

export const KebabBackground = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${colors.gray3};
  visibility: ${(p) => (p.isVisible ? "visible" : "hidden")};
  transition: all 0.2s;
  z-index: ${ZIndex.Header + ZIndex.Popup};
  opacity: 0.25;
`;

export const KebabOption = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 ${DEFAULT_MARGIN_M}px;
  font-size: 12px;
  font-weight: 600;
  color: ${colors.gray3};
  ${defaultLetterSpacing};
  ${defaultTransition};
  cursor: pointer;
  outline: none;

  ${(p) =>
    p.disabled &&
    css`
      cursor: not-allowed;
      background: ${colors.white};
      color: ${colors.gray2};

      svg path {
        stroke: ${colors.gray2};
      }
    `}

  ${media.down("MOBILE")`
    height: 56px;
    padding: 0 ${DEFAULT_MARGIN_L}px;
  `}

  svg {
    margin-right: ${DEFAULT_MARGIN_S}px;
  }

  &:hover {
    background-color: ${(p) => (p.disabled ? colors.white : colors.gray1)};
  }
`;
